import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, InputNumber, Modal } from 'antd';
import { useUpdateClientCreditLimit } from 'api/clients/use-update-client-credit-limit.ts';
import type { IUpdateCreditLimitFormFields, IUpdateCreditLimitModalProps } from './types';

export const UpdateCreditLimitModal: React.FC<IUpdateCreditLimitModalProps> = (props) => {
  const { clientId, creditLimit, isOpen, onClose } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm<IUpdateCreditLimitFormFields>();
  const selectedCreditLimit = Form.useWatch('creditLimit', form);

  const { mutateAsync: updateCreditLimit, isLoading } = useUpdateClientCreditLimit(clientId);

  const onFinish = async (values: IUpdateCreditLimitFormFields) => {
    await updateCreditLimit({ creditLimit: values.creditLimit ?? null });
    onClose();
  };

  const isUnchanged = (selectedCreditLimit ?? null) === (creditLimit ?? null);

  return (
    <Modal
      title={t('client:update_credit_limit')}
      open={isOpen}
      confirmLoading={isLoading}
      okText={t('common:update')}
      okButtonProps={{ disabled: isUnchanged }}
      onCancel={onClose}
      onOk={() => form.submit()}>
      <Form
        form={form}
        name='update_client_credit_limit'
        layout='vertical'
        initialValues={{ creditLimit }}
        onFinish={onFinish}>
        <Form.Item name='creditLimit' label={t('client:credit_limit')} rules={[{ type: 'number', min: 0 }]}>
          <InputNumber min={0} addonAfter='€' style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
